import React from 'react';
import styled from '@emotion/styled';
import Select, { Props } from 'react-select';

import type { IOption } from './types';
import Option from './Option';
import SingleValue from './SingleValue';
import { CLASSNAME_PREFIX, MOBILE_SELECT_VARIABLES } from './constants';

import { Classname } from 'utils/types';

interface IMobileSelect extends Classname, Props<IOption, false> {
  options: IOption[];
  value: IOption;
  onChange: (option: IOption) => void;
}

const MobileSelect: React.FC<IMobileSelect> = ({
  options,
  value,
  onChange,
  className,
  ...props
}) => (
  <Select<IOption>
    className={className}
    options={options}
    onChange={onChange}
    value={value}
    getOptionValue={({ index }) => `${index}`}
    getOptionLabel={({ label }) => label}
    isSearchable={false}
    components={{
      Option: Option,
      SingleValue: SingleValue,
      IndicatorSeparator: null,
    }}
    classNamePrefix={CLASSNAME_PREFIX}
    {...props}
  />
);

const StyledMobileSelect = styled(MobileSelect)`
  ${MOBILE_SELECT_VARIABLES.backgroundColor}:#292929;
  ${MOBILE_SELECT_VARIABLES.textColor}: #fff9;
  ${MOBILE_SELECT_VARIABLES.activeTextColor}: #fff;

  .${CLASSNAME_PREFIX}__ {
    &control {
      border: none;
      border-radius: 2rem;
      box-shadow: none;
      background-color: var(${MOBILE_SELECT_VARIABLES.backgroundColor});
      cursor: pointer;

      &--menu-is-open {
        border-radius: 2rem 2rem 0 0;
      }

      &--is-focused {
        border: none;
      }
    }

    &value-container {
      padding: 0;

      & > * {
        grid-row: 1 / span 1;
        grid-column: 1 / span 1;
      }
    }

    &menu {
      margin: 0;
      border-radius: 0 0 2rem 2rem;
      box-shadow: 0 3rem 3rem 0 #000c;
      background-color: var(${MOBILE_SELECT_VARIABLES.backgroundColor});
      overflow: hidden;
    }

    &menu-list {
      display: grid;
      padding: 0;
      max-height: 29.75rem;

      & > :not(:last-child)::after {
        display: block;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        opacity: 0.125;
        background-color: var(${MOBILE_SELECT_VARIABLES.activeTextColor});
        width: calc(100% - 4rem);
        height: 0.125rem;
        content: '';
      }
    }

    &dropdown-indicator {
      box-sizing: content-box;
      margin-right: 1rem;
      padding: 1.5rem 1rem;
      width: 4rem;
      height: 4rem;
      color: var(${MOBILE_SELECT_VARIABLES.textColor});

      &:hover {
        color: var(${MOBILE_SELECT_VARIABLES.activeTextColor});
      }

      & > svg {
        width: 100%;
        height: 100%;
      }
    }
  }
`;

export default StyledMobileSelect;
